import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import { TESTIMONIALS } from "../../lib/data";

export default function Testimonials() {
    return (
        <section
            data-testid="testimonials-section"
            className="relative py-24 md:py-32 bg-secondary/30"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12">
                <div className="mb-16 max-w-2xl">
                    <div className="text-xs uppercase tracking-widest text-muted-foreground mb-4">
                        Kind words
                    </div>
                    <h2 className="font-display font-light text-4xl md:text-5xl tracking-tighter leading-tight">
                        Trusted by teams who care about{" "}
                        <span className="italic font-medium">
                            building right
                        </span>
                        .
                    </h2>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                    {TESTIMONIALS.map((t, i) => (
                        <motion.figure
                            key={t.name}
                            initial={{ opacity: 0, y: 14 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ delay: i * 0.06 }}
                            data-testid={`testimonial-${i}`}
                            className="p-8 md:p-10 rounded-2xl border border-border bg-card relative"
                        >
                            <Quote className="h-6 w-6 text-foreground/30 mb-5" />
                            <blockquote className="text-base md:text-lg leading-relaxed">
                                &ldquo;{t.quote}&rdquo;
                            </blockquote>
                            <figcaption className="mt-7 flex items-center gap-3">
                                <div className="w-10 h-10 rounded-full bg-foreground text-background grid place-items-center font-display text-sm">
                                    {t.name[0]}
                                </div>
                                <div>
                                    <div className="font-medium text-sm">
                                        {t.name}
                                    </div>
                                    <div className="text-xs text-muted-foreground">
                                        {t.title}
                                    </div>
                                </div>
                            </figcaption>
                        </motion.figure>
                    ))}
                </div>
            </div>
        </section>
    );
}
